import { createFileRoute, useSearch } from '@tanstack/react-router';
import { z } from 'zod';
import { DefaultErrorDisplay } from '@components/error/display/DefaultErrorDisplay';

const errorSearchSchema = z.object({ type: z.string(), message: z.string() }).partial();

export const Route = createFileRoute('/error')({
  validateSearch: errorSearchSchema,
  component: ErrorComponent,
});

function ErrorComponent() {
  const { message } = useSearch({ strict: false });

  return <DefaultErrorDisplay message={message} />;
}
